import {
  Newspaper, FileText, Landmark, Globe, Users, BarChart3, Banknote, TrendingUp,
  Laptop, FlaskConical, HeartPulse, Leaf, Trees, Palette, Clapperboard, Music,
  BookOpen, Shirt, Sparkles, Star, Coffee, Plane, Car, UtensilsCrossed,
  Home as HomeIcon, MapPin, Gamepad2, Building2, Briefcase, GraduationCap,
  ScrollText, Radio, Scale, Church, LayoutGrid,
} from "lucide-react";

// A soccer ball drawn to match the mockup for the "Sport" category.
export const SoccerBall = ({ className, strokeWidth = 2 }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.6l3.4 2.5-1.3 4H9.9l-1.3-4L12 7.6z" />
    <path d="M12 7.6V3.6M15.4 10.1l3.4-1.1M14.1 14.1l2.1 3.2M9.9 14.1l-2.1 3.2M8.6 10.1L5.2 9" />
  </svg>
);

// One dedicated icon per press category (shared by Home + Explorer).
export const CAT_ICON = {
  "Toutes": LayoutGrid,
  "Une": Newspaper,
  "Actualités": FileText,
  "Politique": Landmark,
  "International": Globe,
  "Société": Users,
  "Économie": BarChart3,
  "Finance": Banknote,
  "Bourse": TrendingUp,
  "Sport": SoccerBall,
  "Tech": Laptop,
  "Sciences": FlaskConical,
  "Santé": HeartPulse,
  "Environnement": Leaf,
  "Nature": Trees,
  "Culture": Palette,
  "Cinéma": Clapperboard,
  "Musique": Music,
  "Livres": BookOpen,
  "Mode": Shirt,
  "Beauté": Sparkles,
  "People": Star,
  "Lifestyle": Coffee,
  "Voyage": Plane,
  "Automobile": Car,
  "Cuisine": UtensilsCrossed,
  "Maison": HomeIcon,
  "Régions": MapPin,
  "Loisirs": Gamepad2,
  "Jeux vidéo": Gamepad2,
  "Immobilier": Building2,
  "Emploi": Briefcase,
  "Éducation": GraduationCap,
  "Histoire": ScrollText,
  "Médias": Radio,
  "Justice": Scale,
  "Religion": Church,
  "Magazine": BookOpen,
};

export const catIcon = (name) => CAT_ICON[name] || FileText;
